
<template>
  <div>
    <default-card :outlined="false">
      <template slot="title-left"><span class="ml-n2 title-financial">Informações adicionais ℹ️</span></template>
      <template slot="title-right">
        <!-- <v-btn @click="enableEditing()" text small
          color="normal" 
          class="btn-primary"
          :disabled="loading"
          v-if="!is_editing"
        ><v-icon left>mdi-pencil</v-icon>
          Editar
        </v-btn>

        <v-btn v-if="is_editing" @click="cancelEditing()" small dense text type="submit" class="ml-4 btn-error" align="center">
          <v-icon left>mdi-cancel</v-icon>
          Cancelar
        </v-btn>

        <v-btn v-if="is_editing" @click="submitAdditionalDetails()" small dense text type="submit" class="ml-4 btn-success" align="center">
          <v-icon left>mdi-content-save</v-icon>
          Salvar
        </v-btn> -->

      </template>
      <template slot="content">
        <v-card dense flat>
          <v-card-text class="px-1">
            <v-form :disabled="!is_editing"  ref="form_additional_details" >
              <v-row>
                <v-col cols='12' md='4'>
                  <v-text-field dense outlined v-model="additional_details.work_time" :min="1" type="number" :suffix="additional_details.work_time? 'minutos' : ''" :readonly="!is_editing" label="Tempo Total de Trabalho"></v-text-field>
                </v-col>
                <v-col cols='12' md='4'>
                  <v-text-field dense outlined v-model="additional_details.number_of_shows" :min="1" :rules="additional_details.number_of_shows ? [ruleMaxNumber(10)] : [] " type="number"  :readonly="!is_editing" label="Número de Apresentações"></v-text-field>
                </v-col>
                <v-col cols='12' md='4'>
                  <v-select
                    :items="payment_options" :menu-props="{ bottom: true, offsetY: true }"
                    dense outlined v-model="additional_details.payment_method" :readonly="!is_editing" label="Método de Pagamento"
                  ></v-select>
                </v-col>
              </v-row>
              <span class="text-subtitle-2">Logística</span>
              <v-switch
                :readonly="!is_editing" 
                class="mt-1"
                v-model="additional_details.needs_logistics"
                inset
                dense
                :label="additional_details.needs_logistics ? 'Sim' : 'Não'" 
              ></v-switch>

              <template v-if="additional_details.needs_logistics">
                <span class="text-subtitle-2">Responsável pelo pagamento (Logística)</span>
                <v-radio-group 
                  class="mt-1"
                  row
                  dense
                  mandatory
                  v-model="additional_details.logistics_by" 
                  :rules="required" 
                  :readonly="!is_editing"
                > 
                  <v-radio label="Contratante" value="Contratante"></v-radio>
                  <v-radio :label="activeCompany_name" :value="activeCompany_name"></v-radio>
                </v-radio-group>
              </template>
              <span class="text-subtitle-2">Hospedagem</span>
              <v-switch
                :readonly="!is_editing" 
                class="mt-1"
                v-model="additional_details.needs_accommodation"
                inset
                dense
                :label="additional_details.needs_accommodation ? 'Sim' : 'Não'" 
              ></v-switch>

              <template v-if="additional_details.needs_accommodation">
                <span class="text-subtitle-2">Responsável pelo pagamento (Hospedagem)</span>
                <v-radio-group 
                  class="mt-1"
                  row
                  dense
                  mandatory
                  v-model="additional_details.accommodation_by" 
                  :rules="required" 
                  :readonly="!is_editing"
                > 
                  <v-radio  label="Contratante" value="Contratante"></v-radio>
                  <v-radio :label="activeCompany_name" :value="activeCompany_name"></v-radio>
                </v-radio-group>
              </template>

            </v-form>
          </v-card-text>
        </v-card>
      </template>
      <template slot="actions"></template>
    </default-card>
    <dialog-loading loadingText="Salvando" v-if="saving"></dialog-loading>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex';
import validations from "@/mixins/validations";
import Api from '@/api';

export default {
  name: 'FormAdditionalDetails',
  mixins: [ validations ],
  props: {
    is_component_show_event: {
      type: Boolean
    },
    is_component_create_event: {
      type: Boolean
    },
    event_additional_details: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      is_editing: true,
      loading: false,
      valid: false,
      saving: false,

      payment_options: [
        'Dinheiro',
        'Transferência (Pix/Ted/Doc)',
        'Boleto',
        'Cheque',
        'Cartão de Crédito',
        'Cartão de Débito',
        'Voucher/Bônus',
        'Pagamento Online',
        'Outro',
      ],

      additional_details: {
        payment_method: '',
        work_time: null,
        number_of_shows: '',
        needs_logistics: false,
        logistics_by: '', //:string # 'company' # 'client'
        needs_accommodation: false,
        accommodation_by: '', //:string # 'company' # 'client'
      },
      
    }
  },
  methods: {
    getInfos(){
      this.additional_details = {...this.event_additional_details}
    },
    ...mapActions({
      addNotification: 'Notification/add',
    })
  },
  computed: {
    activeCompany_name(){
      if (this.activeCompany && this.activeCompany.id){
        return this.activeCompany.name
      }
      return 'Empresa'
    },
    ...mapState({
      activeCompany: state => state.App.activeCompany,
    }),
  },
  mounted () {
    this.getInfos()
  },
  watch: {
    'additional_details.payment_method'(){
      this.$emit('adittionalEventUpdated', this.additional_details)
    },
    'additional_details.work_time'(){
      if(this.$refs.form_additional_details.validate()){
        this.$emit('adittionalEventUpdated', this.additional_details)
      }
    },
    'additional_details.number_of_shows'(){
      this.$emit('adittionalEventUpdated', this.additional_details)
    },
    'additional_details.needs_logistics'(nV) {
      if(!nV){
        this.additional_details.logistics_by = ''
      }
      this.$emit('adittionalEventUpdated', this.additional_details)
    },
    'additional_details.logistics_by'(){
      this.$emit('adittionalEventUpdated', this.additional_details)
    },
    'additional_details.needs_accommodation'(nV) {
      if(!nV){
        this.additional_details.accommodation_by = ''
      }
      this.$emit('adittionalEventUpdated', this.additional_details)
    },
    'additional_details.accommodation_by'(){
      this.$emit('adittionalEventUpdated', this.additional_details)
    },
  },
}
</script>

<style scoped>

</style>